import { EditorUtils } from '@ssml-editor/vue';
import { D as DOMEditor } from '../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
import 'vue';

function markClickHandler(editor, node) {
  if (!DOMEditor.isFocused(editor)) {
    DOMEditor.focus(editor);
  }
  const path = EditorUtils.findPath(editor, node);
  if (path) {
    editor.select(path);
  }
  editor.emit("ssml-mark-click", editor, node);
}

export { markClickHandler };
//# sourceMappingURL=menu.method.js.map
